import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as common from '../../../common'
import { passThroughAndValidateNotNull } from '../transformers'

export const DOC = gql`
  fragment FragmentMeAgentForUser on AgentForUser {
    id
    access
    pageContext {
      pageAliases
      isForNonPrebuiltPages
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMeAgentForUserFragment,
  ents.core.agent.Agent.ForUser
>({
  access: passThroughAndValidateNotNull(),
  id: graphql.transformers.OUT.nonNull(common.gql.enums.agentId.TRANSFORMER),
  pageContext: (agent): ents.core.agent.ZoneConfig.PageContext | undefined =>
    agent?.pageContext
      ? {
          isForNonPrebuiltPages:
            agent.pageContext.isForNonPrebuiltPages ?? undefined,
          pageAliases: agent.pageContext.pageAliases ?? undefined,
        }
      : undefined,
})

export const LIST_TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.list(TRANSFORMER, { onNullish: 'remove' }),
  [],
)
